import * as React from 'react'
import { faClose, FaIcon } from '@/lib/fa'
import useGroupService from '../../services/GroupService'
import { toast } from '@/lib/toasts/api'
import ModalLayout from '../shared/ModalLayout'
import AddGroupsForm from '@/modules/drivers/forms/groups/AddGroupsForm'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const EditNameGroupModal = ({
  currenatGroupName,
  close,
  companyId,
  refreshGroups,
  groupId,
}) => {
  const { t } = useLocalize()
  const { changeGroupName } = useGroupService()

  const [newGroupName, setNewGroupName] = React.useState('')
  const [loading, setLoading] = React.useState(false)

  const addDriverGroup = async () => {
    if(newGroupName.trim() === '') {
      toast.error({
        text: t('driverModule.group-name-empty'),
      })
      return
    }
    setLoading(true)
    try {
      await changeGroupName({
        companyId: companyId,
        groupId: groupId,
        newName: newGroupName,
      })
      toast.success({
        text: t('driverModule.group-name-changed'),
      })
    } catch (err) {
      toast.error({
        text: t('driverModule.group-add-failed'),
      })
    } finally {
      setLoading(false)
      refreshGroups()
      close()
    }
  }

  return (
    <ModalLayout>
      <div className="tw-flex tw-max-h-[500px] tw-w-full tw-max-w-[480px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
        <div className="tw-flex tw-items-center tw-justify-between tw-p-4">
          <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
            {t('driverModule.change-group-name')}
          </p>
          <FaIcon
            icon={faClose}
            className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
        <AddGroupsForm
          defaulValue={currenatGroupName}
          setNewGroupName={setNewGroupName}
          newGroupName={newGroupName}
        />
        <div className="tw-flex tw-items-center tw-justify-end tw-border-t tw-border-base-300 tw-px-4">
          <div className="tw-my-4 tw-flex tw-items-center tw-gap-3">
            <button
              disabled={loading}
              type="button"
              onClick={() => addDriverGroup()}
              className={`$tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80`}
            >
              {t('common.confirm')}
            </button>
          </div>
        </div>
      </div>
    </ModalLayout>
  )
}
export default EditNameGroupModal
